module.exports = {"532901001":"大理创新工业园区天井","532901002":"大理创新工业园区满江","532901101":"下关镇","532901102":"大理镇","532901103":"大理创新工业园区凤仪镇","532901104":"喜洲镇","532901105":"海东镇","532901106":"挖色镇","532901107":"湾桥镇","532901108":"银桥镇","532901109":"双廊镇","532901110":"上关镇","532901201":"太邑彝族乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/532901.json
// module id = 2457
// module chunks = 0